module.exports = __webpack_public_path__ + "static/media/mindfulness-for-financial-stress-large@2x.dc4f12b1.png";